// Font settings
export const FONT_FAMILY = 'Roboto, "Helvetica Neue", Arial, sans-serif';

// Chart types
export const CHART_TYPES = {
    BAR: 'bar',
    RADIAL: 'radial',
    TABLE: 'table'
};

// Chart dimensions and spacing
export const CHART_DIMENSIONS = {
    MARGIN: {
        TOP: 30,
        RIGHT: 160,
        LEFT: 0,
        BOTTOM: 30
    },
    BAR: {
        MIN_HEIGHT: 400,
        MIN_SIZE: 50,
        SIZE_INCREMENT: 8, // Size increment per line of text
    },
    RADIAL: {
        MIN_HEIGHT: 400,
        START_ANGLE: 0,
        END_ANGLE: 360,
    },
    ITEM: {
        BASE_HEIGHT: 60,
        LINE_HEIGHT: 20,
    },
    PADDING: {
        CONTAINER: 4,
        CHART_BOTTOM: 100,
    }
};

// Paper styles
export const PAPER_STYLES = {
    CONTAINER: {
        p: CHART_DIMENSIONS.PADDING.CONTAINER,
        backgroundColor: 'unset',
        boxShadow: 'unset',
    }
};

// Title styles
export const TITLE_STYLES = {
    display: 'block'
};

// Text styles with explicit font settings
export const TEXT_STYLES = {
    TITLE: {
        fontSize: '20px',
        fontWeight: 500,
        fontFamily: FONT_FAMILY,
        marginBottom: 2,
    },
    LABEL: {
        fontSize: '20px',
        fontWeight: 500,
        fontFamily: FONT_FAMILY,
        // lineHeight: 1.4,
        overflowWrap: 'break-word',
        whiteSpace: 'normal',
    },
    PERCENTAGE_LABEL: {
        fontSize: '20px',
        fontWeight: 700,
        textShadow: '0 .1px 1px rgba(0,0,0,0.8)',
        fontFamily: FONT_FAMILY,
    },
    AXIS_TICK: {
        fontSize: '18px',
        fontWeight: 500,
        fontFamily: FONT_FAMILY,
    }
};

// Export options with explicit font settings
export const EXPORT_OPTIONS = {
    fileName: 'chart-export.png',
    scale: 2,
    backgroundColor: '#ffffff',
    fontFamily: FONT_FAMILY,
};
